import generalTransformer from '@/services/general/filters/serverTableDataTransformer';
import formatDate from '@/services/general/formatIsoDate';

export default function transformer(serverTableData) {
  if (serverTableData.query.datesEcheance.dateDebut) {
    serverTableData.query.datesEcheance.dateDebut = formatDate(
      serverTableData.query.datesEcheance.dateDebut,
    );
  }
  if (serverTableData.query.datesEcheance.dateFin) {
    serverTableData.query.datesEcheance.dateFin = formatDate(
      serverTableData.query.datesEcheance.dateFin,
    );
  }
  if (serverTableData.query.dateFinContrat.dateDebut) {
    serverTableData.query.dateFinContrat.dateDebut = formatDate(
      serverTableData.query.dateFinContrat.dateDebut,
    );
  }
  if (serverTableData.query.dateFinContrat.dateFin) {
    serverTableData.query.dateFinContrat.dateFin = formatDate(
      serverTableData.query.dateFinContrat.dateFin,
    );
  }
  return generalTransformer(serverTableData);
}
